var _linearGradient, _circle, _linearGradient2, _circle2, _linearGradient3, _path, _linearGradient4, _path2, _linearGradient5, _circle3, _linearGradient6, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKafka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "McNNGNAksUGwd4dZoMtSia",
    x1: 25,
    x2: 25,
    y1: 24.681,
    y2: 35.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#e6abff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 32,
    r: 6,
    fill: "url(#McNNGNAksUGwd4dZoMtSia)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "McNNGNAksUGwd4dZoMtSib",
    x1: 25,
    x2: 25,
    y1: 2.683,
    y2: 15.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#e6abff"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 9,
    r: 5,
    fill: "url(#McNNGNAksUGwd4dZoMtSib)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "McNNGNAksUGwd4dZoMtSic",
    x1: 45.5,
    x2: 45.5,
    y1: 14.815,
    y2: 26.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#e6abff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#McNNGNAksUGwd4dZoMtSic)",
    d: "M49.4,18.25c0.6,1.04,0.76,2.25,0.45,3.41 c-0.31,1.17-1.06,2.14-2.1,2.74c-0.69,0.39-1.46,0.6-2.24,0.6c-0.39,0-0.79-0.05-1.17-0.15c-1.17-0.31-2.14-1.06-2.74-2.1 c-0.6-1.04-0.76-2.25-0.45-3.41c0.31-1.17,1.06-2.14,2.1-2.74c0.69-0.39,1.46-0.6,2.24-0.6c0.39,0,0.79,0.05,1.17,0.15 C47.83,16.46,48.8,17.21,49.4,18.25z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "McNNGNAksUGwd4dZoMtSid",
    x1: 45.5,
    x2: 45.5,
    y1: 38.414,
    y2: 49.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#e6abff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#McNNGNAksUGwd4dZoMtSid)",
    d: "M49.85,42.34 c0.31,1.16,0.15,2.37-0.45,3.41c-0.6,1.04-1.57,1.79-2.73,2.1c-0.39,0.1-0.79,0.15-1.18,0.15c-0.78,0-1.55-0.21-2.24-0.6 c-1.04-0.6-1.79-1.57-2.1-2.74c-0.31-1.16-0.15-2.37,0.45-3.41c0.6-1.04,1.57-1.79,2.73-2.1c0.39-0.1,0.79-0.15,1.18-0.15 c0.78,0,1.55,0.21,2.24,0.6C48.79,40.2,49.54,41.17,49.85,42.34z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "McNNGNAksUGwd4dZoMtSie",
    x1: 25,
    x2: 25,
    y1: 48.976,
    y2: 58.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#e6abff"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 55,
    r: 5,
    fill: "url(#McNNGNAksUGwd4dZoMtSie)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "McNNGNAksUGwd4dZoMtSif",
    x1: 34.503,
    x2: 34.503,
    y1: 0,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#McNNGNAksUGwd4dZoMtSif)",
    d: "M49.75,36.14 C48.44,35.38,46.99,35,45.51,35c-0.74,0-1.48,0.09-2.21,0.29c-1.94,0.52-3.6,1.68-4.74,3.31l-4.43-2.54C34.68,34.82,35,33.45,35,32 s-0.32-2.82-0.87-4.06l4.43-2.54c1.14,1.63,2.8,2.79,4.74,3.31c0.73,0.2,1.48,0.29,2.21,0.29c1.48,0,2.93-0.38,4.24-1.14 c1.97-1.13,3.37-2.97,3.96-5.16c0.59-2.19,0.29-4.48-0.85-6.45c-1.13-1.97-2.97-3.37-5.16-3.96c-0.73-0.2-1.47-0.29-2.21-0.29 c-1.48,0-2.93,0.38-4.24,1.14c-1.97,1.13-3.37,2.97-3.96,5.16c-0.48,1.79-0.36,3.65,0.32,5.34l-4.48,2.56 c-1.63-2.28-4.19-3.86-7.13-4.15v-4.11c4.49-0.5,8-4.32,8-8.94c0-4.96-4.04-9-9-9s-9,4.04-9,9c0,4.62,3.51,8.44,8,8.94v4.11 c-5.05,0.5-9,4.77-9,9.95s3.95,9.45,9,9.95v4.11c-4.49,0.5-8,4.32-8,8.94c0,4.96,4.04,9,9,9s9-4.04,9-9c0-4.62-3.51-8.44-8-8.94 v-4.11c2.94-0.29,5.5-1.87,7.13-4.15l4.48,2.56c-0.68,1.69-0.8,3.55-0.32,5.34c0.59,2.19,1.99,4.03,3.96,5.16 c1.31,0.76,2.76,1.14,4.24,1.14c0.73,0,1.48-0.09,2.21-0.29c2.19-0.59,4.03-1.99,5.16-3.96c1.14-1.97,1.44-4.26,0.85-6.45 C53.12,39.11,51.72,37.27,49.75,36.14z M39.22,18.82c0.45-1.68,1.53-3.08,3.03-3.95c1-0.58,2.11-0.87,3.24-0.87 c0.56,0,1.13,0.07,1.69,0.22c1.68,0.45,3.08,1.53,3.95,3.03s1.1,3.25,0.65,4.93c-0.45,1.68-1.53,3.08-3.03,3.95 c-1,0.58-2.11,0.87-3.24,0.87c-0.56,0-1.13-0.07-1.69-0.22c-1.68-0.45-3.08-1.53-3.95-3.03S38.77,20.5,39.22,18.82z M25,62 c-3.86,0-7-3.14-7-7s3.14-7,7-7s7,3.14,7,7S28.86,62,25,62z M25,40c-4.41,0-8-3.59-8-8c0-4.41,3.59-8,8-8s8,3.59,8,8 C33,36.41,29.41,40,25,40z M25,2c3.86,0,7,3.14,7,7s-3.14,7-7,7s-7-3.14-7-7S21.14,2,25,2z M47.18,49.78 C46.62,49.93,46.06,50,45.49,50c-1.13,0-2.24-0.29-3.24-0.87c-1.5-0.87-2.58-2.27-3.03-3.95c-0.45-1.68-0.22-3.43,0.65-4.93 s2.27-2.58,3.95-3.03c0.56-0.15,1.13-0.22,1.69-0.22c1.13,0,2.24,0.29,3.24,0.87c1.5,0.87,2.58,2.27,3.03,3.95 c0.45,1.68,0.22,3.43-0.65,4.93S48.86,49.33,47.18,49.78z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKafka);
export default __webpack_public_path__ + "static/media/kafka.b025c6b68b175bbb2c3be97423bd307f.svg";
export { ForwardRef as ReactComponent };